













































































































import {
  PayrollChangeRequestStatus,
  PayrollChangeRequestStatusEnum
} from '@/models';
import auth from '@/mixins/auth';
import { IPayrollChangeRequestFetchActionPayload } from '@/store/payrollchangerequest';
import mixins from '@/utils/mixins';

export default mixins(auth).extend({
  name: 'PayrollChangeRequestSerachFilter',

  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      filterParams: {} as IPayrollChangeRequestFetchActionPayload,

      stateList: [
        new PayrollChangeRequestStatus({
          value: PayrollChangeRequestStatusEnum.Draft,
          display_name: 'Draft'
        }),

        new PayrollChangeRequestStatus({
          value: PayrollChangeRequestStatusEnum.Submitted,
          display_name: 'Submitted'
        }),

        new PayrollChangeRequestStatus({
          value: PayrollChangeRequestStatusEnum.InReview,
          display_name: 'Review In Progress'
        }),

        new PayrollChangeRequestStatus({
          value: PayrollChangeRequestStatusEnum.Cancelled,
          display_name: 'Cancelled'
        }),

        new PayrollChangeRequestStatus({
          value: PayrollChangeRequestStatusEnum.Complete,
          display_name: 'Complete'
        })
      ],

      displayList: [
        {
          display_name: 'My Requests',
          value: 'true'
        },
        {
          display_name: 'All Requests',
          value: null
        }
      ]
    };
  },

  computed: {
    openValue: {
      get(): boolean {
        return this.open;
      },
      set(val: boolean) {
        if (val === this.open) return;
        this.$emit('update:open', val);
      }
    }
  },

  methods: {
    closeSearchFilterDialog() {
      this.openValue = false;

      // reset filter params back to empty object
      this.resetFilterParams();
    },

    resetFilterParams() {
      this.filterParams = { self: 'true' };
    },

    openSearchFilterDialog(params: IPayrollChangeRequestFetchActionPayload) {
      if (params.state != null && !isNaN(params.state)) {
        this.filterParams.state = Number(params.state);
      }

      //set value as none if query undefined
      this.filterParams.self = params.self ? params.self : null;

      this.openValue = true;
    },

    save() {
      this.$emit('change', this.filterParams);
      this.closeSearchFilterDialog();
    }
  }
});
